import { render, staticRenderFns } from "./printYCPurReturn.vue?vue&type=template&id=4f7253ae&scoped=true&"
import script from "./printYCPurReturn.vue?vue&type=script&lang=js&"
export * from "./printYCPurReturn.vue?vue&type=script&lang=js&"
import style0 from "./printYCPurReturn.vue?vue&type=style&index=0&id=4f7253ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7253ae",
  null
  
)

component.options.__file = "printYCPurReturn.vue"
export default component.exports